// @ts-nocheck
import AppConfigs from "configs/env";
import { END_POINTS } from "constants/apiUrl";
import { APIUtils } from "utils";

export const checkCampaignApi = (payload) => {
  return APIUtils.get(END_POINTS.CHECK_CAMPAIGN_URL, {
    params: payload,
  });
};

export const getProvincesApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_PROVINCES_URL, {
    params: payload,
    headers: {
      "Api-version": AppConfigs.apiVersionCMS,
    },
  });
};

export const validateCodeApi = () => {
  return APIUtils.post(END_POINTS.VALIDATE_CODE_URL);
};

export const OTPLogApi = (payload) => {
  return APIUtils.post(END_POINTS.OTP_LOG_URL, {
    body: payload,
  });
};

export const requestSMSOTPApi = (payload) => {
  return APIUtils.post(
    END_POINTS.REQUEST_SMS_OTP_URL,

    {
      body: payload,
      headers: { "Ocp-Apim-Subscription-Key": AppConfigs.subscriptionKeyUhub },
    }
  );
};

export const verifyOTPApi = (payload) => {
  return APIUtils.post(END_POINTS.VERIFY_OTP_URL, {
    headers: { "Ocp-Apim-Subscription-Key": AppConfigs.subscriptionKeyUhub },
    body: payload,
  });
};

export const requestLoginApi = (payload) => {
  return APIUtils.post(END_POINTS.REQUEST_LOGIN_URL, {
    body: payload,
  });
};

export const updateUserInfoApi = (payload) => {
  return APIUtils.post(END_POINTS.UPDATE_USER_INFO_URL, {
    body: payload,
  });
};

export const requestGigyaApi = (payload) => {
  return APIUtils.post(END_POINTS.REQUEST_GIGYA_URL, {
    body: payload,
  });
};

export const exchangeCodeApi = (payload) => {
  return APIUtils.post(END_POINTS.EXCHANGE_CODE_URL, {
    body: payload,
  });
};

export const topupMobileApi = (payload) => {
  return APIUtils.post(END_POINTS.TOPUP_MOBILE_URL, {
    body: payload,
    headers: {
      "Ocp-Apim-Subscription-Key": AppConfigs.subscriptionKeyUtop,
    },
  });
};

export const GetDistrictsApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_DISTRICTS_URL, {
    params: payload,
  });
};

export const GetMartsApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_MARTS_URL, {
    params: payload,
  });
};

export const UpdateDeliveryApi = (payload) => {
  return APIUtils.post(END_POINTS.UPDATE_DELIVERY_URL, {
    body: payload,
  });
};

export const CheckPhoneApi = (payload) => {
  return APIUtils.get(
    `${AppConfigs.baseURL}/psldp/phone/check?phone_number=${payload?.phoneNumber}`
  );
};

//kietnva
export const getSlotsApi = (payload) => {
  return APIUtils.get(`${END_POINTS.GOT_SLOTS}?date=${payload.date}`);
};
export const bookTicketApi = (payload) => {
  return APIUtils.post(END_POINTS.BOOK_TICKET, {
    body: payload,
  });
};

// p/s 8/3
export const getCampaignInfoApi = (payload) => {
  return APIUtils.get(`${AppConfigs.baseURL}/psldp/campaign/check`);
};
export const getAllCardsApi = (payload) => {
  const { page, pageSize, isFromUser } = payload;
  return APIUtils.get(
    `${AppConfigs.baseURL}/psldp/cards?page=${page}&pageSize=${pageSize}&isFromUser=${isFromUser}`
  );
};
export const countCardsApi = (payload) => {
  return APIUtils.get(`${AppConfigs.baseURL}/psldp/cards/count`);
};
export const detectImagesApi = (payload) => {
  return APIUtils.post(`${AppConfigs.baseURL}/psldp/images/detect`, {
    body: {
      image_url: payload?.imageUrl,
    },
  });
};
export const detectTextApi = (payload) => {
  return APIUtils.post(`${AppConfigs.baseURL}/psldp/text/detect`, {
    body: {
      texts: payload?.text,
    },
  });
};
export const createCardApi = (payload) => {
  return APIUtils.post(`${AppConfigs.baseURL}/psldp/cards`, {
    body: payload,
  });
};
